/* Product configuration and shared validation.
 * Google Fonts are provisional illustrations, not CJ production fonts.
 * All mappings remain "rough" pending comparison with CJ samples.
 * #41 preserves the Greek cell that is duplicated as "#31" on the chart.
 */
(function () {
  'use strict';

  const NB = window.NB = window.NB || {};
  // v7.17: curated picker. id = supplier font code (F-number, CHIHANG list),
  // desc = gentle Japanese description shown on the left of each row.
  // lang 'ja' fonts are reference-only (お問い合わせ) unless jaPurchasable.
  const F = (id, family, cat, desc, extra = {}) => ({
    id, family, cat,
    label: window.CariamText('font_desc.' + id, desc),
    orderLabel: desc,
    lang: 'en',
    weight: 400,
    ital: false,
    scale: 1,
    latin: true,
    upper: false,
    match: 'rough',
    ...extra
  });
  const J = (id, family, desc, extra = {}) => F(id, family, 'ja', desc,
    { lang: 'ja', latin: false, sample: 'もも', ...extra });

  NB.config = {
    brand: document.body.dataset.brand || '',
    sku: null,
    productTitle: window.CariamText("copy.text_126", 'ネームブレスレット'),
    currency: window.CariamMarket.currency,
    prices: { 1: null, 2: null, 3: null, 4: null },
    shippingPrice: null,
    shippingLabel: window.CariamText("copy.text_232", window.CariamMarket.shippingLabel),

    defaults: {
      count: 1,
      color: 'gold',
      font: 'F01',
      names: ['Momo', 'Yui', 'Ren', 'Haru']
    },

    name: {
      minChars: 1,
      maxChars: 10,
      allowed: /^[A-Za-z]+$/,
      stripInvalid: /[^A-Za-z]/g,
      // v7.19 jp-input: hiragana / katakana names (kanji stays unsupported).
      kanaAllowed: /^[\u3041-\u3096\u30A1-\u30FA\u30FC]+$/,
      // v7.18 fix4: kana the name plate cannot show cleanly. Edit this one string to add/remove characters.
      excludedKana: 'いうえかけこたなにはふほむらがぎぐげござじずぜぞだぢづでどばびぶべぼぱぴぷぺぽぁぃぅぇぉっゃゅょゎゔシソツテニネハホミラリルンガギグゲゴザジズゼゾダヂヅデドバビブベボパピプペポァィゥェォッャュョヮヴり'
    },
    // v7.16: bracelets support one through four names.
    maxNames: 4,

    colors: {
      gold: {
        label: window.CariamText("copy.text_020", 'ゴールドカラー'),
        // Natural break points for the chip label (never orphan 'ー').
        labelParts: [window.CariamText("copy.text_233", 'ゴールド'), window.CariamText("copy.text_066", 'カラー')],
        swatch: 'var(--chip-gold-finish)',
        m: {
          dark: '#675535', mid: '#c0a575', light: '#ebddb3',
          hi: '#faf7e8', engrave: '#58472c', edge: '#a08759'
        }
      },
      silver: {
        label: window.CariamText("copy.text_022", 'シルバーカラー'),
        // Natural break points for the chip label (never orphan 'ー').
        labelParts: [window.CariamText("copy.text_234", 'シルバー'), window.CariamText("copy.text_066", 'カラー')],
        swatch: 'var(--chip-silver-finish)',
        m: {
          dark: '#4d535b', mid: '#a7aeb7', light: '#e6e9ed',
          hi: '#ffffff', engrave: '#3f444b', edge: '#858c95'
        }
      },
      rose: {
        label: window.CariamText("copy.text_024", 'ローズゴールドカラー'),
        // Natural break points for the chip label (never orphan 'ー').
        labelParts: [window.CariamText("copy.text_235", 'ローズ'), window.CariamText("copy.text_233", 'ゴールド'), window.CariamText("copy.text_066", 'カラー')],
        swatch: 'var(--chip-rose-finish)',
        m: {
          dark: '#7a4238', mid: '#c98a7c', light: '#f0c3b4',
          hi: '#fff2ec', engrave: '#6a372f', edge: '#a96a5d'
        }
      }
    },

    /* Distinct illustrative families avoid presenting different CJ numbers
     * with identical samples. Ornaments retain the third version's provisional
     * assignments; their placement and CJ correspondence need sample approval.
     *
     * upper means the family has capital-only Latin glyphs. We NEVER transform
     * names: validation requires explicit uppercase input for those styles.
     */
    // Japanese fonts stay お問い合わせ only. Flip to true to make them
    // selectable/purchasable (also needs Japanese name input support).
    jaPurchasable: true,

    fonts: [
      F('F01', 'Pacifico', 'bold', 'ころんと丸い太めの筆記体'),
      F('F02', 'Damion', 'bold', '軽やかにつながる筆記体'),
      F('F15', 'Grand Hotel', 'bold', 'クラシカルで上品な筆記体'),
      F('F13', 'Lobster', 'bold', 'やわらかな太めの筆記体'),
      F('F26', 'Bebas Neue', 'block', 'すっきりした細身の大文字', { upperDisplay: true }),
      F('F24', 'Archivo Black', 'block', 'しっかり太いブロック文字'),
      F('F37', 'Yellowtail', 'script', 'レトロな雰囲気のつづけ字'),
      F('F38', 'Titan One', 'block', 'ぽってり丸い太字'),
      F('F39', 'Leckerli One', 'bold', '元気で愛らしい太めの筆記体'),
      F('F14', 'Courgette', 'script', 'やさしく読みやすい筆記体'),
      J('F33', 'Dela Gothic One', '力強く存在感のある日本語'),
      J('F32', 'Potta One', '筆で描いたような日本語'),
      J('F34', 'Yusei Magic', 'マーカーで書いたような日本語'),
      J('F40', 'Mochiy Pop One', 'ぽってり可愛い日本語'),
      J('F41', 'Hachi Maru Pop', '丸文字の手書き風日本語'),
      J('F35', 'Zen Antique', 'レトロで落ち着いた日本語')
    ],

    fontCategories: [
      { key: 'en', label: window.CariamText("font_tab.en", '英字') },
      { key: 'ja', label: window.CariamText("font_tab.ja", '日本語') }
    ],

    shipping: {
      productionDays: null,
      transitDays: null,
      totalDays: null,
      holidayCutoff: null,
      holidayCutoffIsEstimate: false,
      holidays: []
    },

    storageKeys: {}
  };

  // Order metadata retains the original Japanese values in every locale.
  // v7.17: orderLabel is set per font in F() (fixed Japanese, never the ID).
  const orderColors = {gold: 'ゴールドカラー', silver: 'シルバーカラー', rose: 'ローズゴールドカラー'};
  Object.entries(NB.config.colors).forEach(([key, color]) => { color.orderLabel = orderColors[key]; });

  NB.productKind = (product = {}) => {
    const suffix = product.template_suffix || product.templateSuffix;
    if (['bracelet', 'necklace', 'pair'].includes(suffix)) return suffix;
    const handle = String(product.handle || '').toLowerCase();
    const type = String(product.type || '').toLowerCase();
    for (const text of [handle, type]) {
      if (/pair|ペア/.test(text)) return 'pair';
      if (/necklace|ネックレス/.test(text)) return 'necklace';
      if (/bracelet|ブレスレット/.test(text)) return 'bracelet';
    }
    return '';
  };
  const C = NB.config;
  const own = (object, key) =>
    Object.prototype.hasOwnProperty.call(object, key);

  const U = NB.util = {
    fontById(id) {
      return C.fonts.find(font => font.id === String(id)) || C.fonts[0];
    },
    latinFonts() {
      return C.fonts.filter(font => font.latin !== false);
    },
    fontSelectable(font) {
      return font.lang !== 'ja' || C.jaPurchasable === true;
    },
    price(count) {
      if (!Number.isInteger(count) || !own(C.prices, count)) return null;
      const price = C.prices[count];
      return Number.isFinite(price) && price > 0 ? price : null;
    },
    cents(value) {
      if (!Number.isFinite(value)) throw new Error(window.CariamText("copy.text_241", '金額を確認できません。'));
      return Math.round(value * 100);
    },
    money(value) {
      if (!Number.isFinite(value)) return window.CariamText("copy.text_163", '未定');
      const format = window.CariamMarket.moneyFormat;
      const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
      if (!match) return format;
      const token = match[1];
      const decimals = token.includes('no_decimals') ? 0 : 2;
      const comma = token.includes('comma_separator');
      const space = token.includes('space_separator');
      const grouped = Number(value).toFixed(decimals).split('.');
      grouped[0] = grouped[0].replace(/\B(?=(\d{3})+(?!\d))/g, space ? ' ' : comma ? '.' : ',');
      return format.replace(match[0], grouped.join(comma ? ',' : '.'));
    },
    colorLabel(key) {
      return own(C.colors, key) ? C.colors[key].label : window.CariamText("copy.text_163", '未定');
    },
    sanitizeName(value) {
      return String(value ?? '')
        .replace(C.name.stripInvalid, '')
        .slice(0, C.name.maxChars);
    },
    isKanaName(value) {
      return typeof value === 'string' && C.name.kanaAllowed.test(value);
    },
    // Latin names use the existing rule; kana names use kanaAllowed.
    validAnyName(value) {
      return U.validName(value) || (typeof value === 'string'
        && value.length >= C.name.minChars
        && value.length <= C.name.maxChars
        && U.isKanaName(value));
    },
    // Kana names need a Japanese font; Latin-only names need a Latin font.
    fontFits(font, names) {
      if (!font) return false;
      const kana = (names || []).some(U.isKanaName);
      return kana ? font.lang === 'ja' : font.latin !== false;
    },
    excludedChars(value) {
      const list = Array.from(C.name.excludedKana || '');
      return Array.from(new Set(Array.from(String(value ?? '')).filter(ch => list.includes(ch))));
    },
    validName(value) {
      return typeof value === 'string'
        && value.length >= C.name.minChars
        && value.length <= C.name.maxChars
        && C.name.allowed.test(value);
    },
    escape(value) {
      return String(value).replace(/[&<>"']/g, char => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;',
        '"': '&quot;', "'": '&#39;'
      })[char]);
    },
    addDays(date, days) {
      const result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    },
    fmtDate(date) {
      return new Date(date).toLocaleDateString('en-US', {
        month: 'short', day: 'numeric'
      });
    },
    fullDate(date) {
      return new Date(date).toLocaleDateString('en-US', {
        month: 'short', day: 'numeric', year: 'numeric'
      });
    },
    reducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    },
    caseWarning(name) {
      if (!name) return '';
      if (name === name.toLowerCase()) return window.CariamText("copy.text_242", 'すべて小文字');
      if (name === name.toUpperCase()) return window.CariamText("copy.text_243", 'すべて大文字');
      return '';
    },

    /* Recurring events roll to the next event, not the next unexpired cutoff.
     * After a cutoff passes, the UI can explicitly say that it has passed.
     * The fixed Mother's Day 2027 entry stays tied to that exact event.
     */
    holidayDates(now = new Date()) {
      const today = new Date(now);
      today.setHours(0, 0, 0, 0);
      if (!Array.isArray(C.shipping.totalDays)) return [];
      return C.shipping.holidays.map(holiday => {
        let year = holiday.year || today.getFullYear();
        let event = new Date(year, holiday.month - 1, holiday.day, 12);
        if (!holiday.year && event < today) {
          year += 1;
          event = new Date(year, holiday.month - 1, holiday.day, 12);
        }
        const cutoff = U.addDays(
          event,
          -C.shipping.totalDays[1] - holiday.bufferDays
        );
        return {
          ...holiday,
          event,
          cutoff,
          estimate: true,
          passed: cutoff < today,
          eventPassed: event < today
        };
      });
    },

    /* Never normalize case, trim silently, or trust a caller's price.
     * A snapshot is a deep-frozen configuration, not proof of consent.
     * Approval is handled separately by NB.approval below.
     */
    snapshot(source, { requireConfirmed = false } = {}) {
      if (!source || !Array.isArray(source.names)) {
        throw new Error(window.CariamText("copy.text_244", '名前を入力してください。'));
      }
      if (source.product !== undefined && !['bracelet','necklace','pair'].includes(source.product)) {
        throw new Error(window.CariamText("copy.text_245", '商品を確認できません。カートからやり直してください。'));
      }
      const count = source.names.length;
      if ((source.product === 'pair' && count !== 2) || count < 1 || count > (source.product === 'necklace' ? 1 : C.maxNames)
          || (source.count !== undefined && source.count !== count)) {
        throw new Error(window.CariamText("copy.text_246", '名前の数を選んでください。'));
      }
      if (!source.names.every(U.validAnyName)) {
        throw new Error(window.CariamText("copy.text_247", '半角英字1〜10文字で入力してください。空白・数字・記号は使えません。'));
      }
      if (source.names.some(ch => U.excludedChars(ch).length)) {
        throw new Error(window.CariamText("copy.kana_unavailable", "この文字は現在お選びいただけません。（[v0]）", {v0: source.names.flatMap(U.excludedChars).join('・')}));
      }
      const font = C.fonts.find(font => font.id === source.font);
      if (!font || !U.fontFits(font, source.names)) {
        throw new Error(window.CariamText("copy.text_248", '選択できる書体を選んでください。'));
      }
      if (!own(C.colors, source.color)) {
        throw new Error(window.CariamText("copy.text_249", 'カラーを選んでください。'));
      }
      if (font.upper && source.names.some(name => name !== name.toUpperCase())) {
        throw new Error(
          window.CariamText("copy.text_250", "[v0] は大文字専用です。大文字で入力するか、別の書体を選んでください。入力は変更していません。", {v0: font.label})
        );
      }
      const price = U.price(count);
      // Unknown preview prices are intentionally null; they do not block spelling review.

      const confirmedAt = source.confirmedAt || null;
      if (requireConfirmed && (
        typeof confirmedAt !== 'string'
        || !Number.isFinite(Date.parse(confirmedAt))
        || new Date(confirmedAt).toISOString() !== confirmedAt
      )) {
        throw new Error(window.CariamText("copy.text_251", 'もう一度、綴りを確認してください。'));
      }
      return Object.freeze({
        product: source.product || 'bracelet',
        names: Object.freeze(source.names.slice()),
        font: font.id,
        color: source.color,
        count,
        price,
        confirmedAt
      });
    },

    signature(source) {
      return JSON.stringify({
        product: source.product || 'bracelet',
        names: source.names,
        font: source.font,
        color: source.color,
        count: source.names.length,
        price: U.price(source.names.length)
      });
    },

    toLineItemProperties(item) {
      const approved = U.snapshot(item, { requireConfirmed: true });
      const properties = {};
      approved.names.forEach((name, index) => {
        properties['名前' + (index + 1)] = name;
      });
      properties['書体'] = U.fontById(approved.font).orderLabel;
      properties['_書体ID'] = approved.font + '-' + U.fontById(approved.font).family;
      properties['カラー'] = C.colors[approved.color].orderLabel;
      properties['_Name count'] = String(approved.count);
      properties['_Spelling confirmed'] = approved.confirmedAt;
      properties['_Case sensitive'] = 'Yes';
      return properties;
    }
  };

  /* One-use in-memory approval capability.
   * Only the confirmation handler should call issue(), after checkbox consent.
   * Every configurator edit calls invalidate(). A stale approved object cannot
   * subsequently be added through NB.cart.add().
   *
   * This prevents accidental UI bypass, not malicious browser modification.
   * A live store must independently validate variants/prices on the server.
   */
  let epoch = 0;
  const issued = new WeakMap();
  NB.approval = {
    invalidate() {
      epoch += 1;
      document.dispatchEvent(new CustomEvent('nb:configuration-edited'));
    },
    revision() {
      return epoch;
    },
    issue(candidate, expectedRevision) {
      if (expectedRevision !== epoch) {
        throw new Error(window.CariamText("copy.text_252", 'デザインが変わりました。もう一度確認してください。'));
      }
      const approved = U.snapshot({
        ...candidate,
        confirmedAt: new Date().toISOString()
      }, { requireConfirmed: true });
      issued.set(approved, epoch);
      return approved;
    },
    assert(approved) {
      if (!issued.has(approved) || issued.get(approved) !== epoch) {
        throw new Error(window.CariamText("copy.text_251", 'もう一度、綴りを確認してください。'));
      }
      U.snapshot(approved, { requireConfirmed: true });
    },
    consume(approved) {
      this.assert(approved);
      issued.delete(approved);
    }
  };

  NB._sections = NB._sections || {};
  NB.registerSection = function (type, init) {
    NB._sections[type] = init;
  };
})();
